<div class="user-profile-menu modal-menu-wrapper openpanel-header-menu">
  <div class="menu-container">
    <!-- Header для profile menu -->
    <div class="header" *ngIf="showHeader && userInfo">
      <div class="menu-image-container">
        <img
          [ngClass]="{
            'no-padding': userInfo.profilePictureThumbnailUrl !== defaultProfileUrl
          }"
          [src]="userInfo.profilePictureThumbnailUrl"
          alt="profile_photo"
          class="profile-photo mr-2"
        />
      </div>
      <div class="menu-user-info full-width">
        <div class="welcome-row">
          <h3>Welcome</h3>
          <a
            [pTooltip]="'Account Settings'"
            [tooltipPosition]="'bottom'"
            class="settings block"
            (click)="onItemClick({type: 'settings'})"
            [routerLink]="['/account/settings']"
          >
          </a>
        </div>
        <h3 class="fullName">
          {{ userInfo.userFullName ? userInfo.userFullName : 'User Name' }}
        </h3>
        <span class="email">
          {{ userInfo.emailId ? userInfo.emailId : 'User Email' }}
        </span>
      </div>
    </div>

    <ul class="body">
      <li *ngFor="let item of menuItems; let i = index">
        <a
          *ngIf="item?.route"
          #rla="routerLinkActive"
          [routerLink]="[item.route]"
          routerLinkActive="active"
          (click)="onItemClick(item)"
        >
          <span>{{ item.label | translate }}</span>
        </a>
        <a
          *ngIf="item?.command && !item?.route"
          (click)="onItemClick(item)"
        >
          <span>{{ item.label | translate }}</span>
        </a>
      </li>
    </ul>
    
    <!-- Menu Footer -->
    <div class="menu-footer mt-0">
      <div
        *ngIf="showHeader"
        (click)="onItemClick({type: 'logout'})"
        class="sign-btn logout-btn"
        translate
      >
        Logout
      </div>
      <div
        *ngIf="!showHeader"
        (click)="onItemClick({label: 'label_sign_in'})"
        class="sign-btn login-btn"
      >
        {{ 'label_sign_in' | translate }}
      </div>
      <div
        *ngIf="!showHeader"
        (click)="onItemClick({label: 'label_sign_up'})"
        class="sign-btn login-btn"
      >
        {{ 'label_sign_up' | translate }}
      </div>
    </div>
  </div>
</div>
